import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/shipping-to-storage.jpg'),
    alt: '/shipping to storage works page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: '/shipping to storage works page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Easy <span>Shipping</span> <span>To Our Storage Facility</span>',
  description:
    'Simplify storage with ShipAndStorage—affordable shipping and retrieval for students, travelers, and those in transition. ',

  image: {
    url: '/images/v2/pages/main-pages/shipping-to-storage/hero-image.jpg',
    alt: 'college storage services page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Shipping' }
}

export const howOurShippingToStorageServicesWorkSectionContent = {
  title: 'How Our Shipping to Storage Services Work',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Schedule Your Pickup' },

  cards: [
    {
      id: 1,
      title: 'Schedule a Pickup',
      description:
        'Book a convenient pickup from your location. Our team handles everything, including boxes, luggage, furniture, and other items.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/schedule-a-pickup.svg',
        alt: 'Schedule a Pickup service'
      }
    },
    {
      id: 2,
      title: 'Safe Storage',
      description:
        'Your items are stored in our climate-controlled, secure facilities. This ensures their safety and protection until you need them.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/safe-storage.svg',
        alt: 'Safe Storage service'
      }
    },
    {
      id: 3,
      title: 'Shipping Options',
      description:
        'When you’re ready, we deliver your stored items back to you or ship them to a new address, depending on your requirements.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/shipping-options.svg',
        alt: 'Shipping Options service'
      }
    }
  ]
}

export const benefitsOfShippingToStorageServicesSectionContent = {
  title: 'Benefits of Shipping to Storage Services',

  cards: [
    {
      id: 1,
      title: 'Hassle-Free Moving Process',
      description:
        'With Shipping to Storage Services, we manage everything from pickup to delivery, reducing stress and saving time.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/hassle-free-moving-process.svg',
        alt: 'Hassle-Free Moving Process service'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Facilities',
      description:
        'All items are stored in climate-controlled, monitored spaces, ensuring they remain in perfect condition.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/secure-storage-facilities.svg',
        alt: 'Secure Storage Facilities service'
      }
    },
    {
      id: 3,
      title: 'Customizable Solutions',
      description: 'Choose services that match your timeline and budget, with no unnecessary extras.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/customizable-solutions.svg',
        alt: 'Customizable Solutions service'
      }
    },

    {
      id: 4,
      title: 'Expert Customer Support',
      description:
        'Our knowledgeable team is available to assist with any questions, providing a smooth and seamless experience.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/expert-customer-support.svg',
        alt: 'Expert Customer Support service'
      }
    },
    {
      id: 5,
      title: 'Sustainability Commitment',
      description: 'ShipAndStorage uses eco-friendly packing materials and energy-efficient storage solutions.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/sustainability-commitment.svg',
        alt: 'Sustainability Commitment service'
      }
    },
    {
      id: 6,
      title: 'Pickup and Delivery Options',
      description:
        'Schedule pickups and deliveries at times that work best for your schedule, whether it’s same-day or planned.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/pickup-and-delivery-options.svg',
        alt: 'Pickup and Delivery Options service'
      }
    }
  ]
}

export const whyWeSectionContent = {
  title: 'Who Can Benefit from Our Services?',

  cards: [
    {
      id: 1,
      title: 'College Students',
      description:
        'Ideal for summer breaks or study abroad. Let us store your dorm essentials while you focus on your studies.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/college-students.svg',
        alt: 'College Students service'
      }
    },
    {
      id: 2,
      title: 'Frequent Travelers',
      description:
        'Store your belongings while you explore the world. Retrieve them anytime with our easy delivery service.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/frequent-travelers.svg',
        alt: 'Frequent Travelers service'
      }
    },
    {
      id: 3,
      title: 'Homeowners',
      description: 'Whether renovating, moving, or downsizing, our services simplify storing your household items.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/homeowners.svg',
        alt: 'Homeowners service'
      }
    },
    {
      id: 4,
      title: 'Businesses',
      description:
        'Companies can securely store equipment, files, and seasonal items, with flexible shipping & storage options.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/businesses.svg',
        alt: 'Businesses service'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'Why Choose Us?',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Here' },

  cards: [
    {
      id: 1,
      title: 'Convenient Service',
      description:
        'Skip the hassle of transporting items yourself. We handle everything, from pickup to storage to delivery.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/convenient-service.svg',
        alt: 'Convenient Service service'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage',
      description:
        'Store only what you need without committing to a full storage unit. Choose a plan that fits your needs.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/flexible-storage.svg',
        alt: 'Flexible Storage service'
      }
    },
    {
      id: 3,
      title: 'Global Network',
      description:
        'Ship to over 220 countries and territories with seamless logistics and reliable partnerships with FedEx and DHL.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/global-network.svg',
        alt: 'Global Network service'
      }
    },
    {
      id: 4,
      title: 'Free Storage',
      description: 'Enjoy up to six months of complimentary storage, with options to extend at affordable rates.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/free-storage.svg',
        alt: 'Free Storage service'
      }
    },
    {
      id: 5,
      title: 'Hands-on Expertise',
      description:
        'With years of experience, we’ve perfected the art of shipping and storage to deliver outstanding service.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/hands-on-expertise.svg',
        alt: 'Hands-on Expertise service'
      }
    },
    {
      id: 6,
      title: 'Pickup and Delivery',
      description:
        'Whether domestic or international, we ensure timely pickups and deliveries tailored to your schedule.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/pickup-and-delivery.svg',
        alt: 'Pickup and Delivery service'
      }
    }
  ]
}

export const additionalServicesWeOfferSectionContent = {
  title: 'Additional Services We Offer',

  cards: [
    {
      id: 1,
      title: 'College Shipping and Storage',
      description: 'Simplify student life with shipping and storage tailored for dorm moves and study abroad programs.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/college-shipping-and-storage.svg',
        alt: 'College Shipping and Storage service'
      }
    },
    {
      id: 2,
      title: 'Long-Term Storage Solutions',
      description: 'Perfect for items you don’t need every day, with flexible options for retrieval and delivery.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/long-term-storage-solutions.svg',
        alt: 'Long-Term Storage Solutions service'
      }
    },
    {
      id: 3,
      title: 'Business Storage and Shipping',
      description: 'Efficiently store and manage inventory, office equipment, and promotional materials.',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/business-storage-and-shipping.svg',
        alt: 'Business Storage and Shipping service'
      }
    },
    {
      id: 4,
      title: 'Moving and Relocation Services',
      description: 'Ship your belongings to your new home or storage location with ease and convenience. ',
      image: {
        src: '/images/v2/pages/main-pages/shipping-to-storage/moving-and-relocation-services.svg',
        alt: 'Moving and Relocation Services service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ready to Simplify Storage?',
  description:
    'With Shipping to Storage Services, storing and retrieving your belongings has never been easier. Get started today and experience the ultimate convenience.',
  image: {
    src: '/images/v2/pages/main-pages/shipping-to-storage/promotional-banner-image.svg',
    alt: 'Ready to Simplify Storage?'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Your Pickup Today' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'How do I schedule a pickup? ',
      answer:
        'Scheduling is simple. Book online or call our customer service team to arrange a pickup time that works for you.'
    },
    {
      id: 2,
      question: 'Are my items insured?',
      answer: 'Yes, every item includes $100 insurance coverage, with options to add more for high-value items.'
    },
    {
      id: 3,
      question: 'Can I access my stored items?',
      answer:
        'Absolutely. You can request item retrieval at any time, either for local delivery or shipping to a new location.'
    },
    {
      id: 4,
      question: 'What types of items can I store?',
      answer: 'You can store almost anything, including boxes, luggage, furniture, bikes, and even small appliances.'
    },
    {
      id: 5,
      question: 'Do you provide packing supplies?',
      answer: 'Yes, we offer boxes, bubble wrap, and other packing materials to ensure your items are well-protected.'
    }
  ]
}
